import { render, staticRenderFns } from "./order-config.vue?vue&type=template&id=7077500e"
import script from "./order-config.vue?vue&type=script&lang=ts"
export * from "./order-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports